import { showSuccessNotify } from "../../utils/Notiffication";
import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/warehouse'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class WarehouseCommonApi {

    static async addToWarehouse({ data = { sku: undefined, skladName: undefined, quantity: undefined, isInventory: undefined }, ...params }) {
        return await fetchService({ url: '/add', method: 'POST', data, ...params })
    }



    static async getProductsBySearch({ data = { search: undefined, tab: undefined, skladName: undefined, providerId: undefined, page: undefined, limit: undefined, address: undefined, }, ...params }) {
        return await fetchService({ url: '/getproducts', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getDebitActions({ data = { search: undefined, tab: undefined, skladName: undefined, providerId: undefined, page: undefined, limit: undefined, address: undefined, historyDateFrom: undefined }, ...params }) {
        return await fetchService({ url: '/getdebitactions', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getOneProduct({ data = { id: undefined }, ...params }) {
        return await fetchService({ url: '/getproduct', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async getProviderProducts({ data = { providerId: undefined, skladName: undefined, search: undefined, page: undefined, limit: undefined }, ...params }) {
        return await fetchService({ url: '/getproviderproducts', method: 'POST', data, notify: { success: false }, ...params })
    }



    static async changeProduct({ data = { warehouseId: undefined, field: undefined, value: undefined, action: undefined, reason: undefined, isInventory: undefined, skladName: undefined, postingNumber: undefined, historyId: undefined }, ...params }) {
        return await fetchService({ url: '/changeproduct', method: 'PATCH', data, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.warehouseId} сохранены`); return r })
    }

    static async changeMarketPairs({ data = { warehouseId: undefined, newWarehouseId: undefined }, ...params }) {
        return await fetchService({ url: '/changemarketspairs', method: 'PATCH', data, ...params })
    }




    static async deleteOne({ data = { id: undefined }, ...params }) {
        return await fetchService({ url: '/deleteone', method: 'DELETE', data, ...params })
    }



    // static async inventoryPlace({ data = { address: undefined }, ...params }) {
    //     return await fetchService({ url: '/inventoryplace', method: 'POST', data, ...params })
    // }




    static async findAddress({ data = { search: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/findaddress', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async addAddress({ data = { address: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/addaddress', method: 'POST', data, ...params })
    }



    static async excelHistory({ data = { search: undefined, tab: undefined, days: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/excelhistory', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelData({ data = { search: undefined, tab: undefined, address: undefined, providerId: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/exceldata', method: 'POST', data, options: { download: true }, ...params })
    }



    static async addToYandexExpress({ data = { providerId: undefined, shop: undefined, warehouseIds: undefined }, ...params }) {
        return await fetchService({ url: '/addtoyandexexpress', method: 'POST', data, ...params })
    }

    static async addToKuper({ data = { providerId: undefined, shop: undefined, warehouseIds: undefined }, ...params }) {
        return await fetchService({ url: '/addtokuper', method: 'POST', data, ...params })
    }



    static async sendToContent({ data = undefined, ...params }) {
        return await fetchService({ url: '/sendtocontent', method: 'POST', data, ...params })
    }

    static async excelWbBarcodes({ data = { address: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/excelwbbarcodes', method: 'POST', data, options: { download: true }, ...params })
    }

}